export default {
    MORNING: 'morning',
    EVENING: 'evening',
    ANYTIME: 'anytime',
};